// Copyright 2016 Sorama B.V.

import { IValueConverter } from "aurelia-binding-ext";

export class IntegerToStringValueConverter implements IValueConverter<string, number> {
    public toView(value: number): string {
        return value.toString();
    }

    public fromView(value: string): number {
        return parseInt(value);
    }
}
